import { configureStore } from "@reduxjs/toolkit";
import postReducer from "../features/postSlice";
import eventReducer from "../features/eventSlice";
import authReducer from "../features/authSlice";

export const store = configureStore({
  reducer: { posts: postReducer, event: eventReducer , auth : authReducer },
});
